import { MetricBar } from "@/components/ui/table";

export const DIRECTION_LABELS: Record<string, string> = {
  inbound: "Inbound",
  "inbound direct": "Inbound Direct",
  outbound: "Outbound",
  internal: "Internal",
};

export function formatDirectionForDisplay(raw: string): string {
  const key = raw.trim().replace(/-/g, " ").replace(/\s+/g, " ").toLowerCase();
  if (!key) return "-";
  return DIRECTION_LABELS[key] ?? raw;
}

export const formatDuration = (seconds: number): string => {
  if (!seconds) return "00:00:00";
  const h = Math.floor(seconds / 3600);
  const m = Math.floor((seconds % 3600) / 60);
  const s = seconds % 60;
  const pad = (n: number) => String(n).padStart(2, "0");
  return `${pad(h)}:${pad(m)}:${pad(s)}`;
};

export const formatRelativeTime = (isoOrRaw: string | null): string => {
  if (!isoOrRaw) return "—";
  const normalized = /[Zz]$|[+-]\d{2}:\d{2}$/.test(isoOrRaw) ? isoOrRaw : isoOrRaw + "Z";
  const ms = new Date(normalized).getTime();
  if (isNaN(ms)) return isoOrRaw;
  const sec = Math.max(0, Math.floor((Date.now() - ms) / 1000));
  if (sec < 60) return `${sec} ${sec === 1 ? "second" : "seconds"} ago`;
  const min = Math.floor(sec / 60);
  if (min < 60) return `${min} ${min === 1 ? "minute" : "minutes"} ago`;
  const hr = Math.floor(min / 60);
  if (hr < 24) return `${hr} ${hr === 1 ? "hour" : "hours"} ago`;
  const days = Math.floor(hr / 24);
  return `${days} ${days === 1 ? "day" : "days"} ago`;
};

export const renderMetricBar = (numVal: number, pct: number, barColorClass: string, labelClassName: string, label: string) => (
  <MetricBar value={numVal} pct={pct} displayText={label} barClassName={barColorClass} labelClassName={labelClassName} />
);

export const getSlaColors = (numVal: number) => {
  if (numVal >= 80) return { text: "text-success", bar: "bg-success" };
  if (numVal >= 70) return { text: "text-caution", bar: "bg-caution" };
  return { text: "text-destructive", bar: "bg-destructive" };
};

export const getTransferredPctColors = (numVal: number) => {
  if (numVal >= 50) return { text: "text-destructive", bar: "bg-destructive" };
  if (numVal >= 30) return { text: "text-caution", bar: "bg-caution" };
  return { text: "text-success", bar: "bg-success" };
};
